// Utility to generate and print the Harta list by Zon & Kategori Kutipan
// Usage: await printHartaPreview({ zon, kategori_kutipan })

import { apiGetHartaForPrint } from "api/harta";

function buildPrintHtml({ data = [], filters = {}, currentUser = {} }) {
  const sortedData = [...data].sort((a, b) => {
    const aKod = (a.kod_harta || "").toString();
    const bKod = (b.kod_harta || "").toString();
    return aKod.localeCompare(bKod, undefined, { sensitivity: "base", numeric: true });
  });

  const titleLines = [
    `LAPORAN SENARAI HARTA ${currentUser.bahagian ? currentUser.bahagian.toUpperCase() : ""}`,
  ];
  if (filters.zon) titleLines.push(`Zon: ${filters.zon}`);
  if (filters.kategori_kutipan) titleLines.push(`Kategori Kutipan: ${filters.kategori_kutipan}`);

  return `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="utf-8" />
        <title>Laporan Senarai Harta</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; font-size: 12px; }
          .header { text-align: center; margin-bottom: 20px; }
          .title { font-weight: bold; font-size: 14px; margin-bottom: 10px; }
          .logo-kejora { display: block; margin: 0 auto 8px auto; height: 48px; }
          table { width: 100%; border-collapse: collapse; border: 1px solid black; }
          th, td { border: 1px solid black; padding: 4px; text-align: left; font-size: 10px; }
          th { background-color: #f0f0f0; font-weight: bold; text-align: center; }
          .number { text-align: center; }
          .footer { margin-top: 20px; display: flex; justify-content: space-between; font-size: 10px; }
          .amount { text-align: right; }
          @media print { body { margin: 10px; } .no-print { display: none; } }
        </style>
      </head>
      <body>
        <div class="header">
          <img src="/build/kejora.png" alt="KEJORA" class="logo-kejora" />
          <div class="title">${titleLines.join("<br/>")}</div>
          <div>Tarikh: ${new Date().toLocaleDateString("ms-MY")}</div>
        </div>
        <table>
          <thead>
            <tr>
              <th style="width: 30px;">BIL</th>
              <th style="width: 70px; text-align:center;">KOD HARTA</th>
              <th style="width: 230px;">ALAMAT</th>
              <th style="width: 100px;">ZON</th>
              <th style="width: 120px;">KATEGORI KUTIPAN</th>
              <th style="width: 100px;">KADAR SEWA (RM)</th>
            </tr>
          </thead>
          <tbody>
            ${sortedData
              .map(
                (row, index) => `
              <tr>
                <td class="number">${index + 1}</td>
                <td style="text-align:center;">${row.kod_harta || "-"}</td>
                <td>${row.alamat1_harta || ""} ${row.alamat2_harta || ""}</td>
                <td>${row.zon || "-"}</td>
                <td>${row.kategori_kutipan || "-"}</td>
                <td class="amount">${row.kadar_sewa ? Number(row.kadar_sewa).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00"}</td>
              </tr>
            `
              )
              .join("")}
          </tbody>
        </table>
        <div class="footer">
          <div>Jumlah rekod: ${sortedData.length}</div>
          <div>Dicetak pada: ${new Date().toLocaleString("ms-MY")}</div>
        </div>
      </body>
    </html>
  `;
}

export async function printHartaPreview({ zon = "", kategori_kutipan = "" } = {}) {
  const filters = { zon, kategori_kutipan };
  const response = await apiGetHartaForPrint(filters);
  const data = response?.data || [];

  if (!data || data.length === 0) {
    alert("Tiada data untuk dicetak.");
    return false;
  }

  const printWindow = window.open("", "_blank");
  if (!printWindow) {
    alert("Gagal membuka tetingkap cetakan.");
    return false;
  }

  const currentUser = JSON.parse(localStorage.getItem("user") || "{}");
  const html = buildPrintHtml({ data, filters, currentUser });

  printWindow.document.write(html);
  printWindow.document.close();

  // Allow a tick for layout before printing
  setTimeout(() => {
    try {
      printWindow.focus();
      printWindow.print();
    } catch (_) {
      // no-op
    }
  }, 500);

  return true;
}

export default printHartaPreview;
